module.exports = __webpack_public_path__ + "static/media/nodejs.67ee91dc.png";